module.exports = __webpack_public_path__ + "static/git-commits-6c664ad182fc670bd6e4ea13984576f4.png";